import { useGetBlog } from '@app/Hooks/use-blogs';
import React, { useState } from 'react';
import BlogPostCard from './components/blog-post-card';
import SearchContent from './components/search-content';
import useDebounce from '@app/Hooks/useDebounce';
import GenerateBlogModal from './components/generate-blog-modal';
import EmptyBlogPost from './components/empty-blog-post';

const Blogs = () => {
  //   const [page, setPage] = useState(1);
  const [searchString, setSearchString] = useState('');
  const [show, setShow] = useState(false);
  const [selected, setSelected] = useState(null);
  const debouncedTerm = useDebounce(searchString, 500);
  const { data, isLoading } = useGetBlog({
    page: 1,
    limit: 10,
    search: debouncedTerm,
    status: selected
  });

  const handleSearch = (value) => {
    setSearchString(value);
  };

  const handleStatus = (value) => {
    setSelected(value);
  };

  return (
    <div className="p-7">
      <GenerateBlogModal isOpen={show} onOpenChange={setShow} />
      <SearchContent
        handleSearch={handleSearch}
        searchString={searchString}
        handleStatus={handleStatus}
        selected={selected}
        isBlogs={data?.blogs && data?.blogs?.length > 0}
        openGenerate={() => setShow(true)}
      />
      {!isLoading && data?.blogs && data?.blogs?.length === 0 ? (
        <div className="grid place-items-center h-[50dvh]">
          <EmptyBlogPost />
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-4">
          {isLoading
            ? [...new Array(10)].map((_, idx) => (
                <div
                  key={idx}
                  className="flex flex-col border border-black/[0.07] rounded-2xl overflow-hidden cursor-pointer"
                >
                  <div className="h-48 bg-gray-200 naimate-pulse" />
                  <div className="flex flex-col flex-1 p-5">
                    <div className="w-[200px] animate-pulse bg-gray-200 h-5 rounded-lg mb-2.5" />
                    <div className="mb-4 w-full h-10 bg-gray-200 rounded-lg animate-pulse" />

                    <div className="flex items-center justify-between pt-4 border-t border-black/[0.06]">
                      <div className="flex gap-3 items-center">
                        {[...new Array(3)].map((_, id) => (
                          <div
                            key={id}
                            className="flex-1 w-[50px] h-5 bg-gray-200 rounded-lg animate-pulse"
                          />
                        ))}
                      </div>

                      <div className="w-[100px] h-5 bg-gray-200 rounded-lg animate-pulse" />
                    </div>
                  </div>
                </div>
              ))
            : data?.blogs?.map((blog) => {
                return <BlogPostCard post={blog} />;
              })}
        </div>
      )}
    </div>
  );
};

export default Blogs;
